import { idb } from "utils"
import { store } from "@redux/store"
import * as types from "../types/offlineOrders"

export const fetchOfflineOrders = () => (
  async (dispatch) => {
    const branchId =
      store.getState().userAccountInfo.branchId

    try {
      const offlineOrdersFromDatabase =
        await idb.getAllItemsFromDatabase(
          branchId,
          "offlineOrders"
        )

      dispatch({
        type: types.FETCH_OFFLINE_ORDERS,
        offlineOrders: offlineOrdersFromDatabase.reverse()
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const addOfflineOrder = newOfflineOrder => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "offlineOrders",
    [newOfflineOrder]
  )

  return {
    type: types.ADD_OFFLINE_ORDER,
    newOfflineOrder
  }
}

export const editOfflineOrder = (offlineOrderId, offlineOrder) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  const targetOfflineOrder =
    store.getState().offlineOrders.find(o =>
      o.offlineOrderId === offlineOrderId
    )

  idb.saveItemsToDatabase(
    branchId,
    "offlineOrders",
    [{ ...targetOfflineOrder, ...offlineOrder }]
  )

  return {
    type: types.EDIT_OFFLINE_ORDER,
    offlineOrderId,
    offlineOrder
  }
}

export const replaceOfflineOrder = (offlineOrderId, offlineOrder) => ({
  type: types.REPLACE_OFFLINE_ORDER,
  offlineOrderId,
  offlineOrder
})

export const deleteOfflineOrder = offlineOrderId => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.deleteItemsFromDatabase(
    branchId,
    "offlineOrders",
    [offlineOrderId]
  )

  return {
    type: types.DELETE_OFFLINE_ORDER,
    offlineOrderId
  }
}

export const deleteAllOfflineOrders = () => ({
  type: types.DELETE_ALL_OFFLINE_ORDERS
})